import React, { useEffect, useState, useRef } from 'react'
import Header from '../Header/Header.js'
import { GoCircle } from "react-icons/go";
import { SlLocationPin } from "react-icons/sl";
import { GET_ORDERS_BY_ID } from '../graphql/Query/Order.js';
import { useMutation, useQuery } from '@apollo/client';
import moment from 'moment';
import Swal from "sweetalert2";
import { createRoot } from 'react-dom/client';
import { Link, useLocation } from 'react-router-dom';
import { CANCEL_ORDER, UPDATE_ORDER } from '../graphql/Mutation/Ordre.js';
// import { toast } from 'react-toastify';
import PriceCalculator from '../DocumentShiping/priceCalculator.js';
import Invoice from '../Common/Invoice.js';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { useModal } from '../Contex.js';
import Accordion from '../Home/Accodion.js';
import { handleLogin } from '../Common/TokenLogin.js';
import Table from "../components/Table/index.jsx";
import { BsBox, BsBoxSeam } from "react-icons/bs";
import { SlClose } from "react-icons/sl";
import { MdDirectionsBike } from "react-icons/md";
import { LiaTruckMovingSolid } from "react-icons/lia";
import { FaCheckCircle, FaRegCheckCircle } from "react-icons/fa";
import useScrollToTop from '../components/useScrollToTop.js';
import { MdContentCopy } from "react-icons/md";
import CustomLabel from '../Common/CustomLabel.js';
import SpinLoader from '../components/SpinLoader.js';
import { allowedPincodes } from './PincodeService.js';
import { API_URL, COURIER_PASSWORD, COURIER_USERNAME } from '../config.js';
import axios from 'axios';
import { handleDownload } from '../Common/DownloadLabel.js';
import SideBar from './SideBar.js';
import { toast } from 'react-toastify';
import { GET_WALLET_BALANCE } from '../graphql/Query/Wallet.js';

// export const ecomStatusMap = {
//     403: "'PP",
//     101: 'PP',   // Soft data uploaded
//     102: 'PP',   // Pickup assigned
//     103: 'PP',   // Out for pickup
//     104: 'PP',   // Pickup failed
//     105: 'PP',   // Pickup rescheduled for next day
//     106: 'CL',   // Pickup cancelled by ecom
//     107: 'CL',   // Pickup cancelled by shipper
//     108: 'PP',   // Field pickup done
//     109: 'IT',   // Origin facility inscan
//     110: 'IT',   // Bagged
//     112: 'OFD',   // Undelivered
//     113: 'DL',   // Delivered
//     114: 'RT',   // Returned
//     115: 'RT-LT',// Shipment lost
//     116: 'RT-DG',// Shipment damaged
//     117: 'RT',   // Destroyed
//     118: 'PP',   // Pickup unassigned
//     119: 'PP',   // Pickup redirected
//     120: 'OFD',  // DRS created
//     121: 'OFD',  // Out for delivery
//     122: 'IT',   // Shipment inscan at location
//     123: 'IT',   // Shipment debagged at location
//     124: 'IT',   // Bag inscan at location
//     125: 'IT',   // Bag added to connection
//     126: 'IT',   // Departed from location
//     127: 'RT',   // RTO lock
//     128: 'IT',   // RTO lock revoked
//     129: 'OFD',  // OFD lock
//     130: 'OFD',  // OFD lock revoked
//     131: 'RT',   // DMG lock
//     132: 'RT',   // DMG lock revoked
//     133: 'IT',   // DC inscan
//     135: 'IT',   // Mass update
//     136: 'IT',   // Sal tally scan on shipment
//     137: 'IT',   // Shipment misrouted - delay in delivery expected
//     138: 'IT',   // Misrouted due to ecom's fault
//     139: 'IT',   // Bag received after cut-off
//     77: 'RT',
//     777: 'RT',
//     80: 'RT',
//     83: "OFD",
//     82: "OFD",
//     210: "OFD",
//     6: "OFD",
//     5: "IT",
//     3: "IT",
//     2: "IT",
//     11: "PP",
//     1230: "PP",
//     1: "PP",
//     999: 'DL',
//     1350: "PP",
//     404: "CL",
//     417: "OFD",
//     222: "OFD",   // Address incorrect
//     224: "OFD",   // Address unlocatable
//     22701: "OFD", // Shipment attempted - residence closed
//     22704: "OFD", // Customer refused delivery at doorstep
//     22705: "OFD", // Could not be delivered - vehicle breakdown/accident
//     23101: "OFD", // Customer out of station
//     23102: "OFD", // Customer not available at office
//     24202: "OFD", // Cannot be attempted - due to capacity/time constraint
//     24204: "OFD", // Delivery attempted - OTP not available
//     24455: "OFD", // Capacity constraint at customer
// };

// export function mapEcomCodeToAppStatus(code) {
//     console.log('✌️code --->', code);
//     if (!code) return 'IT'; // fallback
//     const numericCode = parseInt(code, 10);
//     console.log('✌️numericCode --->', numericCode);
//     return ecomStatusMap[numericCode] || 'IT'; // default to 'IT' if not found
// }
export function parseEcomResponse(xmlString) {
    // console.log('✌️xmlString --->', xmlString);
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlString, "text/xml");
    const awbObj = xmlDoc.querySelector("object[model='awb']");
    if (!awbObj) return null;

    // Get "scans" objects
    const scansField = awbObj.querySelector("field[name='scans']");
    const history = [];
    if (scansField) {
        const scanObjects = scansField.querySelectorAll("object[model='scan_stages']");
        scanObjects.forEach((scanObj) => {
            const scanData = {};
            scanObj.querySelectorAll("field").forEach((f) => {
                const name = f.getAttribute("name");
                const value = f.textContent.trim();
                scanData[name] = value;
            });
            history.push(scanData);
        });
    }

    // Transform each scan to unify status codes
    const unifiedHistory = history.map((scan) => {
        // const code = scan?.reason_code_number; // or "status_code_number"
        return {
            ...scan,
            // status_code: mapEcomCodeToAppStatus(code),
            event_time: scan?.updated_on,
            location: scan?.location_city || scan?.location || '',
            message: scan?.status, // e.g. "Shipment RTO Lock"
        };
    });

    // Example: find an overall status from the last event
    const lastEvent = unifiedHistory[0];
    // console.log('✌️lastEvent --->', lastEvent);

    // let overallStatus = 'in transit';
    // if (lastEvent?.status_code === 'CL') overallStatus = 'cancelled';
    // if (lastEvent?.status_code === 'RT') overallStatus = 'rto';
    // if (lastEvent?.status_code === 'DL' && (lastEvent &&
    //     lastEvent?.location_type === "Delivery Center" &&
    //     lastEvent?.message === "Delivered")) overallStatus = 'delivered';
    // if (lastEvent?.status_code === 'PP') overallStatus = 'pending pickup';
    // if (lastEvent?.status_code === 'OFD') overallStatus = 'out for delivery';
    // if (lastEvent?.status_code === 'IT') overallStatus = 'in transit';
    // if (lastEvent &&
    //     lastEvent?.location_type === "Return Center" &&
    //     lastEvent.message === "Delivered") overallStatus = 'rto delivered';

    return {
        // status: overallStatus, // e.g. 'cancelled', 'rto', 'delivered', or 'in_transit'
        history: unifiedHistory,
    };
}


const SingleTrack = () => {
    useScrollToTop();
    const lastStatusRef = useRef(null);
    const pollingIntervalRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const iconRefs = useRef([]);
    const [lineHeights, setLineHeights] = useState([]);
    const { openModal } = useModal();
    const [cancelCourier] = useMutation(CANCEL_ORDER, {
        refetchQueries: [
            {
                query: GET_WALLET_BALANCE,
            }
        ]
    });
    const [showMore, setShowMore] = useState(false);
    const [shipmentData, setShipmentData] = useState(null);
    const [copySuccess, setCopySuccess] = useState(false);
    // console.log('✌️shipmentData --->', shipmentData);
    const location = useLocation();
    const getId = location?.state?.id
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("id");
    const activeButton = location?.state?.activeButton
    const { data: GetOrderOrder, refetch } = useQuery(GET_ORDERS_BY_ID, {
        variables: {
            "getOrderId": getId || id
        },
        fetchPolicy: "cache-and-network"
    });
    // console.log('✌️GetOrderOrder --->', GetOrderOrder);
    // const [updateCourier] = useMutation(UPDATE_ORDER);
    useEffect(() => {
        const heights = iconRefs.current.map((ref, index) => {
            if (index < iconRefs.current.length - 1) {
                const currentIcon = ref.getBoundingClientRect();
                const nextIcon = iconRefs.current[index + 1].getBoundingClientRect();
                return nextIcon.top - currentIcon.bottom;
            }
            return 0;
        });
        setLineHeights(heights);
    }, [shipmentData, showMore]);

    const handleDownloadInvoice = () => {
        const invoiceElement = document.getElementById('invoice');
        if (!invoiceElement) {
            return;
        }

        invoiceElement.style.visibility = 'visible';
        invoiceElement.style.position = 'static';

        html2canvas(invoiceElement, { scale: 2 })
            .then((canvas) => {
                const imgData = canvas.toDataURL('image/png');
                const pdf = new jsPDF('p', 'mm', 'a4');
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
                pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
                pdf.save(`invoice_${GetOrderOrder?.getOrder?.order_id}.pdf`);

                invoiceElement.style.visibility = 'hidden';
                invoiceElement.style.position = 'absolute';
            })
            .catch((error) => console.error('Error generating PDF:',));
    };

    const order = GetOrderOrder?.getOrder;
    const isCancelled = order?.trackStatus === 'Shipment Cancelled';
    const isConfirmed = order?.trackStatus === 'Shipment Booking Confirmed';


    // const invoiceRef = useRef(null);
    // const handleDownloadLabel = () => {
    //     setLoading(true);
    //     const invoiceElement = document.getElementById('label');
    //     // console.log('✌️invoiceElement --->', invoiceElement);
    //     if (!invoiceElement) {
    //         setLoading(false);
    //         return;
    //     }

    //     // Set visibility and position for capturing the element
    //     invoiceElement.style.visibility = 'visible';
    //     invoiceElement.style.position = 'static';

    //     html2canvas(invoiceElement, { scale: 2 })
    //         .then((canvas) => {
    //             const imgData = canvas.toDataURL('image/png');

    //             // Set the PDF dimensions to 4 inches by 6 inches
    //             const pdf = new jsPDF('p', 'in', [4, 6]); // 'p' for portrait, dimensions in inches
    //             const pdfWidth = 4; // PDF width in inches
    //             const pdfHeight = 6; // PDF height in inches

    //             // Calculate canvas dimensions in inches for scaling
    //             const canvasWidthInches = canvas.width / 96; // Canvas width in inches (assuming 96 DPI)
    //             const canvasHeightInches = canvas.height / 96; // Canvas height in inches (assuming 96 DPI)
    //             const scale = Math.min(pdfWidth / canvasWidthInches, pdfHeight / canvasHeightInches);

    //             const scaledCanvasWidth = canvasWidthInches * scale;
    //             const scaledCanvasHeight = canvasHeightInches * scale;

    //             // Add image to the PDF with scaling
    //             pdf.addImage(
    //                 imgData,
    //                 'PNG',
    //                 (pdfWidth - scaledCanvasWidth) / 2, // Center horizontally
    //                 (pdfHeight - scaledCanvasHeight) / 2, // Center vertically
    //                 scaledCanvasWidth,
    //                 scaledCanvasHeight
    //             );

    //             pdf.save(`label_${GetOrderOrder?.getOrder?.order_id}.pdf`);

    //             // Revert visibility and position styles
    //             invoiceElement.style.visibility = 'hidden';
    //             invoiceElement.style.position = 'absolute';
    //         })
    //         .catch((error) => {
    //             console.error('Error generating PDF:', error); // Log error
    //             // setLoading(false); // End loading on error
    //         })
    //         .finally(() => {
    //             setLoading(false); // End loading after the operation is complete
    //         });
    // };

    const handleCancelCourier = async (awbNumber) => {
        Swal.fire({
            title: "Are You Sure You Want to Cancel Your Shipment ?",
            html: `<p class="swal-professional-text">
  Are you sure you want to cancel your shipment? Please click the 
  <strong>'Cancel Shipment'</strong> button below to confirm your cancellation.  
  Alternatively, if you wish to proceed with the delivery, you can ignore this message.  
  If you have any questions, feel free to contact us for assistance.
</p>`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#1F2937",  // Dark gray color for a professional feel
            cancelButtonColor: "#B8B8B8",   // Lighter color for the cancel button
            confirmButtonText: "Yes, cancel it!",
            cancelButtonText: "No, keep it",
            customClass: {
                title: "swal-professional-title",
                text: "swal-professional-text",
                confirmButton: "swal-professional-button",
                cancelButton: "swal-professional-button",
                icon: "swal-professional-icon"
            },
            backdrop: true,
            // padding: '30px',
            showClass: {
                popup: 'animate__animated animate__zoomIn',
            },
            hideClass: {
                popup: 'animate__animated animate__zoomOut',
            }
        }).then(async (result) => {
            if (result?.isConfirmed) {
                try {
                    const { data } = await cancelCourier({ variables: { awbNumber } });
                    if (data?.cancelCourier) {
                        toast.success('Shipment cancelled successfully!');
                        refetch();
                        if (GetOrderOrder?.getOrder?.Shipment_name !== "AJ") {
                            trackShipment();
                        }
                    }
                } catch (error) {
                    toast.error(error?.message)
                }
            }
        });

    };
    // const [ setDeliveryData] = useState(null);
    const handleDownloadLabel = async () => {
        setLoading(true);

        // Create a temporary container off-screen
        const container = document.createElement("div");
        container.style.position = "absolute";
        container.style.top = "-9999px";
        container.style.visibility = "visible";
        document.body.appendChild(container);

        // Render your CustomLabel into this container
        const root = createRoot(container);
        root.render(
            <CustomLabel key={GetOrderOrder?.getOrder?._id} order={GetOrderOrder?.getOrder} />
        );

        // Wait for the label to render (adjust delay as needed)
        await new Promise((resolve) => setTimeout(resolve, 500));

        try {
            // Use html2canvas to capture the rendered label
            const canvas = await html2canvas(container, { scale: 2 });
            const imgData = canvas.toDataURL("image/png");

            // Create the PDF (adjust dimensions as needed)
            const doc = new jsPDF("p", "pt", [285, 437]);
            const pdfWidth = doc.internal.pageSize.getWidth();
            const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

            // Add the captured image to the PDF
            doc.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);



            // Save the PDF
            doc.save(`${GetOrderOrder?.getOrder?.order_number}.pdf`);
        } catch (error) {
            console.error("Error generating label:", error);
        }

        // Clean up: unmount the temporary component and remove the container
        root.unmount();
        document.body.removeChild(container);

        setLoading(false);
    };



    const handleCopy = (awbNumber) => {
        // Use the Clipboard API to copy the text
        navigator.clipboard.writeText(awbNumber)
            .then(() => {
                setCopySuccess(true);
                setTimeout(() => {
                    setCopySuccess(false);
                }, 2000);
            })
            .catch(err => {
                console.error('Failed to copy text: ', err);
            });
    };

    const capitalizeFirstLetter = (text) => {
        if (!text) return text;
        return text.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
    };


    const trackShipment = async () => {
        // const awb = 10588034049;
        const awb = GetOrderOrder?.getOrder?.awb_number;
        if (GetOrderOrder?.getOrder?.Shipment_name === "EC") {
            try {
                const response = await axios.get(`${API_URL}/track-awb`, {
                    params: { awb }
                });
                // console.log('✌️response --->', response);
                if (response?.status === 200) {
                    const parsed = parseEcomResponse(response?.data);
                    // console.log('✌️parsed --->', parsed);
                    setShipmentData({ data: parsed });
                }
            } catch (error) {
                // console.log('✌️error --->', error);
            }
        } else {
            const authToken = await handleLogin();

            const url = `https://shipment.xpressbees.com/api/shipments2/track/${awb}`;
            try {
                if (GetOrderOrder?.getOrder?.awb_number && awb) {
                    const response = await axios.get(url, {
                        headers: {
                            'Authorization': `Bearer ${authToken}`,
                            'Content-Type': 'application/json',
                        }
                    });

                    const data = response?.data;
                    setShipmentData(data);
                }
            } catch (err) {

            }
        }
    };
    useEffect(() => {
        if (GetOrderOrder?.getOrder?.Shipment_name !== "AJ") {
            trackShipment();
        }
    }, [GetOrderOrder?.getOrder?.awb_number])

    // const handleToggle = () => setShowMore(!showMore);
    // let statusOrder;

    // switch (shipmentData?.data?.status) {
    //     case 'cancelled':
    //         statusOrder = ['PP', 'CL'];
    //         break;
    //     case 'rto':
    //         statusOrder = ['PP', 'IT', 'OFD', 'EX', 'RT', 'RT-IT', 'RT-DL'];
    //         break;
    //     case 'exception':
    //         statusOrder = ['PP', 'IT', 'OFD', 'EX', 'DL'];
    //         break;
    //     default:
    //         statusOrder = ['PP', 'IT', 'OFD', 'DL'];
    //         break;
    // }

    // const getLatestStatusCode = (history) => {
    //     if (history.length > 0) {
    //         // console.log("history[history.length - 1].status_code",history[history.length - 1].status_code,history[history.lengt])
    //         // return history[history.length - 1].status_code;
    //         // console.log("history[0].status_code", history[0].status_code);
    //         return history[0].status_code;
    //     }
    //     return null;
    // };

    // const visibleStatuses = showMore ? statusOrder : statusOrder.slice(0, 3);

    // const getStatus = (status) => {
    //     switch (status) {
    //         case 'PP':
    //             return 'Courier Confirmed';
    //         case 'IT':
    //             return 'In Transit';
    //         case 'OFD':
    //             return 'Out for Delivery';
    //         case 'DL':
    //             return (<><p>Delivery Successfully</p><p className="text-sm text-gray-500 font-normal">Your item has been delivered</p></>);
    //         case 'CL':
    //             return shipmentData?.data?.status === "cancelled" ? <> <p>Shipment Cancelled</p> <p className='text-sm text-gray-500'>Your Shipment has been cancelled.</p> <p className='text-sm text-gray-500'>You have cancelled this Shipment.</p> </> : '';
    //         case 'RT':
    //             return shipmentData?.data?.status === "rto" ? <> <p>Shipment RTO</p> <p className='text-sm text-gray-500'>Your Shipment has been RTO.</p> </> : '';
    //         case 'RT-IT':
    //             return 'RTO In Transit';
    //         case 'RT-LT':
    //             return 'RTO In Lost';
    //         case 'RT-DG':
    //             return 'RTO In Damaged';
    //         case 'RT-DL':
    //             return (<><p>RTO Delivery Successfully</p><p className="text-sm text-gray-500 font-normal">Your RTO item has been delivered</p></>);
    //         case 'EX':
    //             return 'Exception'
    //         default:
    //             return status;
    //     }
    // };


    // const getIconColor = (history, targetStatus, isCancelled, rto) => {
    //     // console.log('✌️history, targetStatus, isCancelled, rto --->', history, targetStatus, isCancelled, rto);
    //     if (isCancelled && targetStatus === 'CL') {
    //         return 'bg-red-500 border-red-200';
    //     }
    //     // if (rto && targetStatus === 'RT') {
    //     //     return 'bg-blue-500 border-blue-200';
    //     // }

    //     const latestStatusCode = getLatestStatusCode(history);
    //     // console.log('✌️latestStatusCode --->', latestStatusCode);
    //     const latestIndex = statusOrder.indexOf(latestStatusCode);
    //     // console.log('✌️latestIndex --->', latestIndex);
    //     const targetIndex = statusOrder.indexOf(targetStatus);
    //     // console.log('✌️targetIndex --->', targetIndex);

    //     if (latestIndex >= targetIndex) {
    //         return 'bg-green-500 border-green-200';
    //     } else {
    //         return 'bg-slate-400 border-gray-200';
    //     }
    // };
    // const getLineColor = (history, targetStatus, isCancelled, rto) => {
    //     if (isCancelled && targetStatus === 'CL') {
    //         return 'bg-green-400';
    //     }
    //     if (isCancelled && targetStatus === 'RT') {
    //         return 'bg-green-400';
    //     }

    //     const latestStatusCode = getLatestStatusCode(history);
    //     // console.log('✌️latestStatusCode --->', latestStatusCode);
    //     const latestIndex = statusOrder.indexOf(latestStatusCode);
    //     // console.log('✌️latestIndex --->', latestIndex);
    //     const targetIndex = statusOrder.indexOf(targetStatus);
    //     // console.log('✌️targetIndex --->', targetIndex);

    //     if (latestIndex >= targetIndex) {
    //         return 'bg-green-500';
    //     } else {
    //         return 'bg-slate-400';
    //     }
    // };


    // const contentRef = useRef();

    // const generatePDF = () => {
    //   const doc = new jsPDF('p', 'pt', [288, 432]);

    //   // Capture HTML content using jsPDF's html method
    //   doc.html(contentRef.current, {
    //     // margin: [20, 20, 20, 20], // margins for the PDF
    //     callback: function (doc) {
    //       doc.save('static_ad.pdf');
    //     },
    //     x: 10, // X-axis offset
    //     y: 10, // Y-axis offset
    //   });
    // };
    // const allowedPincodes = ['395006', '110001', '40001', '400028']; // List of allowed pincodes
    const currentPincode = GetOrderOrder?.getOrder?.pickupAddress?.zipCode;
    const columns = [
        {
            name: "Weight (Kg)",
            selector: (row) => row?.package_weight_Length ?? "-",
            sortable: true
        },
        {
            name: "Product Category",
            selector: (row) => row?.ProductName ?? "-",
            sortable: true
        },
        {
            name: "Quantity",
            selector: (row) => "1",
            sortable: true
        },
        {
            name: "Payment Type",
            selector: (row) => row?.payment_type ?? "-",
            sortable: true
        },
        {
            name: "Product Total",
            selector: (row) => row?.payment_type === "prepaid" ? row?.ProductPrice : "-",
            sortable: true
        },
        {
            name: "Collectible Value",
            selector: (row) => row?.payment_type === "cod" ? row?.ProductPrice : "-",
            sortable: true
        },

    ];
    return (
        <div>
            {/* <div>
            <div
                ref={invoiceRef}
                // style={{ border: '1px solid #000', padding: '20px', width: '300px', height: '200px' }}
            >
                <h2>Invoice</h2>
                <p>Order ID: 12345 kjbkjblnsf;vndogerninergjengioengolenorn</p>
                <p>Product: Awesome Widget</p>
                <p>Price: $19.99</p>
            </div>

            <button onClick={handleDownloadLabel} disabled={loading}>
                {loading ? 'Generating PDF...' : 'Download Label as PDF'}
            </button>
        </div> */}

            {/* <div className="flex items-center justify-center h-screen">
      <div ref={contentRef} className="w-72 h-108 p-4 border-2 border-gray-300">
        <h1 className="text-3xl font-bold text-center text-blue-600">Big Sale! 50% OFF!</h1>
        <p className="text-lg text-center">Shop now and get amazing discounts on selected items. Don't miss out!</p>
        <footer className="mt-4 text-center text-sm">
          Visit us at www.yourwebsite.com
        </footer>
      </div>

      <button
        onClick={generatePDF}
        className="mt-4 px-6 py-3 text-white bg-blue-500 rounded hover:bg-blue-600"
      >
        Download 4x6 Ad PDF
      </button>
    </div> */}
            <Header />
            <div className="flex  bg-slate-100 min-h-screen overflow-hidden">
                {/* Sidebar */}
                <SideBar />

                <div className="flex-1 space-y-3 md:p-6 overflow-x-hidden ml-16">
                    <h1 className="text-xl font-bold mt-6 mx-4 md:mt-0 md:mx-0 mb-4">Tracking History</h1>
                    <div className='border bg-white border-gray-300 p-2 rounded-md md:space-y-6 space-y-9'>
                        <div className='py-6 md:px-6  flex space-x-3 flex-col md:flex-row justify-between items-start md:items-center'>
                            {/* Left Section: Shipment Details */}
                            <div className='w-full px-4 md:px-0 md:w-3/5'>
                                <div
                                    className={`text-lg flex md:flex-row items-center font-semibold ${isCancelled ? 'text-red-500' : 'text-green-500'
                                        }`}
                                >
                                    <BsBox className="text-2xl hidden md:block text-start mr-3 drop-shadow-lg" />
                                    <h1 className="text-start">Domestic Shipment Services Across India</h1>
                                </div>



                                <div className={`text-md font-semibold mt-2 ${isCancelled ? 'text-red-500' : 'text-green-500'}`}>
                                    {order?.trackStatus}
                                </div>
                                <p className='mt-2 text-xs'>We are pleased to inform you that UK Logistics uses advanced digital tracking technology to provide real-time updates on your shipment. You can track your parcel anytime using our online tracking system.</p>
                                {/* Action Buttons */}
                                <div className='flex flex-wrap gap-3 mt-8'>
                                    <Link to='/accordionhelp'>
                                        <button className='px-6 py-1 rounded-md bg-slate-900 text-white  hover:bg-slate-800 transition'>Help</button>
                                    </Link>

                                    {allowedPincodes.includes(currentPincode) && order?.awb_number && isConfirmed && activeButton === 'All Courier' ? (
                                        <button
                                            onClick={handleDownloadLabel}
                                            className='px-4 py-1 rounded-md bg-green-600 hover:bg-green-700 text-white  transition'
                                            disabled={loading}
                                        >
                                            {loading ? 'Loading...' : 'Download Label'}
                                        </button>
                                    ) : (
                                        !allowedPincodes.includes(currentPincode) && (
                                            <button onClick={() => handleDownload(order?.label, order?.Shipment_name)} className='px-4 py-1 rounded-md bg-green-600 hover:bg-green-700 text-white  transition'>
                                                Download Label
                                            </button>
                                        )
                                    )}

                                    {/* {order?.awb_number && isConfirmed && (
                                        <button
                                            className='px-4 py-1 rounded-md bg-slate-900 text-white  hover:bg-slate-800 transition'
                                            onClick={handleDownloadInvoice}
                                        >
                                            Download Invoice
                                        </button>
                                    )} */}

                                    {((shipmentData?.data || order?.status) && !['exception', 'cancelled', 'in transit', 'delivered', 'out for delivery', 'rto', 'rto delivered'].includes(shipmentData?.data?.status || order?.status)) && (
                                        <button
                                            className='px-4 py-1 rounded-md border border-red-500 text-red-500 hover:bg-red-500 hover:text-white transition'
                                            onClick={() => { handleCancelCourier(order?.awb_number) }}
                                        >
                                            Cancel Shipment
                                        </button>
                                    )}
                                </div>
                            </div>

                            {/* Right Section: Payment and Shipment Info */}


                        </div>
                        <div className='grid gap-x-3 grid-cols-1 md:grid-cols-2 md:px-4 pb-1 lg:grid-cols-3 gap-y-3'>
                            <div className='space-y-4 p-5 border border-gray-300 rounded-md'>
                                <p className='text-md font-semibold border-b pb-3'>Address Details</p>
                                <div className='flex space-x-4'>
                                    <div className='space-y-1 text-gray-400'>
                                        <GoCircle />
                                        <ul className='ms-1.5'>
                                            {[...Array(13)].map((_, i) => (
                                                <li key={i} className={`text-xs leading-3 ${i >= 13 ? 'sm:hidden' : ''}`}>I</li>
                                            ))}
                                        </ul>
                                        <SlLocationPin />
                                    </div>
                                    <div className='space-y-8 w-full  text-ellipsis overflow-hidden'>
                                        <div>
                                            <p className='text-sm font-semibold mb-1'>
                                                {capitalizeFirstLetter(GetOrderOrder?.getOrder?.pickupAddress?.name)}
                                                <p className='text- text-gray-400'>-Pickup</p>
                                            </p>
                                            <p className='text-sm text-wrap'>
                                                {capitalizeFirstLetter(GetOrderOrder?.getOrder?.pickupAddress?.address1)},
                                                <p className='text-sm text-wrap'>{capitalizeFirstLetter(GetOrderOrder?.getOrder?.pickupAddress?.city)}. {capitalizeFirstLetter(GetOrderOrder?.getOrder?.pickupAddress?.stateId?.name)} - {GetOrderOrder?.getOrder?.pickupAddress?.zipCode}</p>
                                            </p>
                                            <p className='text-sm text-gray-500 text-wrap'>
                                                {GetOrderOrder?.getOrder?.pickupAddress?.phone}
                                            </p>
                                        </div>
                                        <div>
                                            <p className='text-sm font-semibold mb-1 text-wrap'>
                                                {capitalizeFirstLetter(GetOrderOrder?.getOrder?.deliveryAddress?.name)}
                                                <p className='text- text-gray-400'>-Delivery</p>
                                            </p>
                                            <p className='text-sm text-wrap'>
                                                {capitalizeFirstLetter(GetOrderOrder?.getOrder?.deliveryAddress?.address1)},
                                                <p className='text-sm text-wrap'> {capitalizeFirstLetter(GetOrderOrder?.getOrder?.deliveryAddress?.city)}. {capitalizeFirstLetter(GetOrderOrder?.getOrder?.deliveryAddress?.stateId?.name)} - {GetOrderOrder?.getOrder?.deliveryAddress?.zipCode}</p>
                                            </p>
                                            <p className='text-sm text-gray-500 text-wrap'>
                                                {GetOrderOrder?.getOrder?.deliveryAddress?.phone}
                                            </p>
                                        </div>
                                    </div>

                                </div>


                            </div>

                            {
                                shipmentData && (
                                    <>
                                        <div className="w-full mx-auto p-5 border border-gray-300 rounded-md">
                                            <p className="text-md font-semibold mb-4 border-b pb-3">Shipment Tracking</p>
                                            <div className="relative flex flex-col mt-6 items-start space-y-8">
                                                <div className="relative mt-4 pl-1 min-w-max w-full">
                                                    {/* Vertical Line */}
                                                    <div className="absolute left-[15px] top-2 bottom-0 w-[2px] bg-green-400 transition-colors group-hover:bg-black"></div>

                                                    {shipmentData?.data?.history?.map((event, index) => {
                                                        return (
                                                            <div key={index} className="relative flex items-start gap-4 mb-6 group">
                                                                {/* Icon Container for Proper Alignment */}
                                                                <div className="relative flex items-center">
                                                                    <FaCheckCircle className="text-green-500 text-2xl bg-white rounded-full z-10 transition-colors" />
                                                                </div>

                                                                {/* Event Details */}
                                                                <div className="space-y-1 text-xs sm:text-sm">
                                                                    <p className="font-semibold text-gray-900">{event?.event_time}</p>
                                                                    <p className="text-gray-600">{event?.location}</p>
                                                                    <p className="text-gray-700">{event?.message}</p>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )
                            }

                            {/* {shipmentData && (
                                <div className="w-full mx-auto p-5 border border-gray-300 rounded-md">
                                    <p className="text-md font-semibold mb-4 border-b pb-3">Shipment Tracking</p>
                                    <div className="relative flex flex-col items-start space-y-8">
                                        {statusOrder.map((status, index) => {
                                            const isCancelled = shipmentData?.data?.status === "cancelled";
                                            // const rto = shipmentData?.data?.status === "rto";

                                            return (
                                                <React.Fragment key={index}>
                                                    <div className="flex items-center space-x-4">
                                                        <div className="relative">
                                                            <div
                                                                ref={(el) => iconRefs.current[index] = el}
                                                                className={`${getIconColor(shipmentData?.data?.history, status, isCancelled)} ${shipmentData?.data?.status === "pending pickup" && status === 'PP' ? 'bg-green-500 border-green-200' : ''} border-4 text-white p-1.5 rounded-full`}
                                                            >
                                                                {status === 'PP' && <BsBoxSeam />}
                                                                {status === 'IT' && <LiaTruckMovingSolid />}
                                                                {status === 'OFD' && <MdDirectionsBike />}
                                                                {status === 'EX' && <MdDirectionsBike />}
                                                                {status === 'DL' && <FaRegCheckCircle />}
                                                                {status === 'CL' && isCancelled && <SlClose />}
                                                                {status === 'RT' && <SlClose />}
                                                                {status === 'RT-IT' && <SlClose />}
                                                                {status === 'RT-LT' && <SlClose />}
                                                                {status === 'RT-DG' && <SlClose />}
                                                                {status === 'RT-DL' && <SlClose />}
                                                            </div>
                                                            {index < statusOrder.length - 1 && (
                                                                <div
                                                                    style={{ height: `${lineHeights[index]}px` }}
                                                                    className={`${getLineColor(shipmentData?.data?.history, statusOrder[index + 1], isCancelled)} absolute left-1/2 transform -translate-x-1/2 w-px`}
                                                                />
                                                            )}
                                                        </div>
                                                        <div>
                                                            <h2 className="font-medium text-sm">{getStatus(status)}</h2>
                                                            <p className="text-sm text-gray-500">
                                                                {shipmentData?.data?.history.find(hist => hist?.status_code === status)?.event_time || ''}
                                                            </p>
                                                        </div>
                                                    </div>

                                                    {!isCancelled && showMore && shipmentData?.data?.history
                                                        .filter(hist => hist?.status_code === status)
                                                        .reverse()
                                                        .map((hist, histIndex) => (
                                                            <div key={histIndex} className="flex items-start ml-8 space-x-4">
                                                                <div className="w-px bg-slate-300" style={{ height: 'auto' }}></div>
                                                                <div>
                                                                    <p className="text-sm font-semibold">{hist?.event_time}</p>
                                                                    <p className="text-sm text-gray-500">{hist?.location}</p>
                                                                    <p className="text-sm text-gray-500">{hist?.message}</p>
                                                                    {hist?.reason_code && hist?.reason_code !== '-' ? <p className="text-sm text-gray-500">{hist?.reason_code}</p> : ''}
                                                                </div>
                                                            </div>
                                                        ))}
                                                </React.Fragment>
                                            );
                                        })}
                                    </div>
                                    <button onClick={handleToggle} className="mt-7 text-black ml-7 flex font-semibold text-sm focus:outline-none">
                                        {showMore ? 'SHOW LESS' : 'SHOW MORE'} <span className='self-center text-xl'>{showMore ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}</span>
                                    </button>
                                </div>
                            )} */}

                            <div className="p-5 border border-gray-300 rounded-lg bg-white shadow-sm">
                                <p className="text-md font-semibold mb-4 border-b pb-3">Package Info</p>

                                {/* Payment Type & Amount */}
                                <div className="flex items-center justify-between mb-3">
                                    <span className="text-lg font-semibold text-gray-900">
                                        {order?.payment_type?.toUpperCase()}
                                        {order?.payment_type === "cod" && ` ₹${order?.ProductPrice}`}
                                    </span>
                                </div>

                                {/* Shipment Details */}
                                <div>
                                    <div className="space-y-4">
                                        <p className="text-sm font-medium text-gray-600">
                                            Shipment ID: <span className="text-gray-900">{order?.order_id}</span>
                                        </p>
                                        <p className="text-sm font-medium text-gray-600">
                                            Shipment No.: <span className="text-gray-900">{order?.order_number}</span>
                                        </p>
                                        <p className="text-sm font-medium text-gray-600 flex items-center">
                                            AWB NO.: <span className="ml-1 text-gray-900">{order?.awb_number}</span>
                                            <MdContentCopy
                                                onClick={() => handleCopy(order?.awb_number)}
                                                className="ml-2 text-lg cursor-pointer text-blue-600 hover:text-blue-800 transition duration-200"
                                            />
                                        </p>
                                        {copySuccess && <p className="text-green-600 text-sm">Copied to clipboard!</p>}
                                        <p className="text-sm text-gray-800">{moment(order?.createdAt).format("DD/MM/YYYY")}</p>

                                        {/* <div className="sticky text-sm bottom-0 bg-slate-100 px-4 py-3 sm:px-6 rounded-b-lg"> */}
                                        {/* <p className='text-sm'>You can track your shipment using the AWB number.</p> */}
                                        {/* </div> */}
                                    </div>

                                </div>

                            </div>

                        </div>


                        <div id="hidden-invoice-container" style={{ visibility: 'hidden', position: 'absolute', top: '-9999px' }}>
                            <Invoice order={GetOrderOrder?.getOrder} />
                        </div>

                    </div>


                    <div className="mt-2 bg-white p-4 border rounded-lg">
                        <h2 className="text-lg font-semibold mb-4 text-gray-900 border-b pb-2">
                            Package Details
                        </h2>
                        <Table
                            columns={columns}
                            data={GetOrderOrder?.getOrder ? [GetOrderOrder.getOrder] : []}
                        />

                    </div>
                </div>
            </div>

        </div>
    )
}

export default SingleTrack
